import React from 'react'
import { Row, Col,Calendar,CalendarProps } from 'antd'
import type { Dayjs } from 'dayjs';

const AppointmentCalender = () => {
    const onPanelChange = (value: Dayjs, mode: CalendarProps<Dayjs>['mode']) => {
        console.log(value.format('YYYY-MM-DD'), mode);
      };
  return (
    <div>
        <Row>
            <Col span={24}>
            <Calendar onPanelChange={onPanelChange} />
            </Col>
        </Row>
    </div>
  )
}

export {AppointmentCalender}